import React from "react";
import styled from "styled-components";
import { Link } from "gatsby";
// import ApplyNowModal from "./ApplyNowModal";
import ReactMarkdown from "react-markdown";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useEffect } from "react";
import DescriptionBlock from "../Home/DescriptionBlock"
const StyledWrapper = styled.div`
  .margin-top {
    margin-top: 50px;
  }

  .apply-now {
    padding: 3% 0;
  }

  .flat-button {
    color: white;
    font-size: 32px;
    font-weight: 800;
    letter-spacing: 0;
    line-height: 43px;
    margin: auto;
    @media (max-width: 600px) {
      font-size: 22px;
    }
  }

  .flat-btn-link {
    margin: auto;
    display: block;
    text-decoration: none;
    text-align: center;
  }

  .flat-btn-link:hover {
    color: white;
  }

  .program-support {
    color: #000000;
    font-size: 25px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 44px;
    text-decoration: none;

    @media (max-width: 600px) {
      font-size: 15px;
      line-height: normal;
    }
  }

  .please-note-links {
    color: #000000;
    font-size: 17px;
    letter-spacing: 0;
    line-height: 27px;
    text-decoration: underline;

    @media (max-width: 600px) {
      font-size: 15px;
    }
  }

  .subtext li {
    @media (max-width: 600px) {
      margin-top: 10px;
    }
  }

  .subtext a {
    color: black;
    text-decoration: underline;
  }

  .subtext ul {
    padding-left: 0;
  }

  .toast-bar {
    color: white;
    background-color: #4dd2ff;
    font-size: 16px;
    letter-spacing: 0.5px;
  }

  .toast-bar-progress {
    background: #00bfff;
  }

  .subtext > ol {
    padding-left: 0;
  }
    ul {
    padding-left: 0; /* Remove left padding */
    margin: 0; /* Remove margin */
  }
     ol {
    padding-left: 0; /* Remove left padding */
    margin: 0; /* Remove margin */
  }
    .iframe-wrapper {
    padding: 20px 0; /* Add padding above and below the iframe */
  }

    .content iframe {
    @media (min-width: 300px) and (max-width: 600px) {
      width: 100%;
      height: 148px;
    }
      @media (min-width: 768px) and (max-width: 860px) 
      width: 100%;
      height: 300px;
    }
    @media (min-width: 200px) and (max-width: 280px) {
      width: 237px;
      height: 134px;
    }
`;

// Preserve campaign attribution when the form is hosted on another domain.
const goToFormWithUTMs = (path = '') => {
  const sourceParams = new URLSearchParams(window.location.search);
  const keys = [
    'utm_source', 'utm_medium', 'utm_campaign',
    'utm_term', 'utm_content',
    'gclid', 'fbclid', 'ttclid'
  ];
  const destination = new URL(
    `${process.env.GATSBY_FORM_URL}${path}`,
    window.location.origin
  );

  keys.forEach(k => {
    if (sourceParams.get(k)) destination.searchParams.set(k, sourceParams.get(k));
  });

  destination.searchParams.set('form_source', window.location.hostname);
  const consentGranted = window.upreachTrackingConsent === true ||
    window.localStorage.getItem('upreachTrackingConsent') === 'granted';
  if (consentGranted) {
    destination.searchParams.set('tracking_consent', 'granted');
  } else {
    destination.searchParams.set('tracking_consent', 'denied');
  }

  let redirected = false;
  const redirect = (linkerParam) => {
    if (redirected) return;
    redirected = true;
    if (linkerParam) destination.searchParams.set('_gl', linkerParam);
    window.location.assign(destination.toString());
  };

  if (typeof window.gtag === 'function') {
    window.gtag('get', 'G-YSME7QSYQZ', 'linker_param', redirect);
    window.setTimeout(() => redirect(), 1000);
  } else {
    redirect();
  }
};

const trackApplyClick = () => {
  if (typeof window === 'undefined') return;

  if (typeof window.gtag === 'function') {
    window.gtag('event', 'begin_apply', { event_category: 'Apply Now' });
  }
  if (typeof window.fbq === 'function') {
    window.fbq('track', 'InitiateCheckout');
  }
  if (window.ttq && typeof window.ttq.track === 'function') {
    window.ttq.track('ClickButton', { content_name: 'Apply Now' });
  }
};

const ApplyNowSummary = ({ data }) => {
  //comeneted due to Tc.852 change form model popup to New page
  // const [modalOpen, setModalOpen] = React.useState();
  const [urlToken, setUrlToken] = React.useState();
  useEffect(() => {
    if(window.location.search){
      // setModalOpen(true);
      // window.location.href = '/apply-now/submit'
      let token = window.location.search.replace("?", '');
      setUrlToken(token);
      window.scrollTo(0,0);
      // Redirect to form with UTMs preserved
      goToFormWithUTMs();
    }
  }, [])

  const notify = () =>
    toast(
      "Thank you for registering for support from upReach. We will be in contact shortly.",
      {
        className: "toast-bar",
        progressClassName: "toast-bar-progress",
        autoClose: 5000,
      }
    );

    const notifyFn1 = () =>
    toast(
      "Thank you for saving your data.",
      {
        className: "toast-bar",
        progressClassName: "toast-bar-progress",
        autoClose: 5000,
      }
    );

    const renderContent = (contentt) => {
      const content = contentt.replace(/`/g, "");

      const iframeRegex = /<iframe.*?<\/iframe>/g;
      const parts = content.split(iframeRegex); 
      const iframes = content.match(iframeRegex); // Extract the iframe tags
  
      const elements = []; 
  
      parts.forEach((part, index) => {
        
        elements.push(
          <ReactMarkdown key={`markdown-${index}`}>{part}</ReactMarkdown>
        );
  
        // If there's an iframe at this position, push it
        if (iframes && iframes[index]) {
          
          elements.push(
            <div
              key={`iframe-${index}`} className="iframe-wrapper"
              dangerouslySetInnerHTML={{ __html: iframes[index] }}
            />
          );
        }
      });
  
      return elements;
    };

  return (
    <StyledWrapper>
      <ToastContainer />
      <div className="content">
      <div className="container-fluid padding-left-8 padding-right-8">
        <div className="col">
          <div className="col-12">
            <div className="margin-top">
              <p className="subtext">{data.subText}</p>
              <Link className="program-support mt-3" to="">
                {data.LinkText}
              </Link>
            </div>
            <div className="margin-top">
              <h1>{data.applyHeading}</h1>
              <ol className="subtext p-0">
              {/* <DescriptionBlock description={data.applyDescription}/> */}
                {/* <ReactMarkdown source={data.applyDescription} /> */}
                {renderContent(data.applyDescription)}
              </ol>
            </div>
            <div className="margin-top">
              {/* <ReactMarkdown
                className="subtext p-0"
                source={data.applyDescription2}
              /> */}
              {renderContent(data.applyDescription2)}
              {/* <DescriptionBlock description={data.applyDescription}/> */}
            </div>
            {/* <div className="margin-top">
              <h2>PLEASE NOTE:</h2>
              <ol className="subtext">
                <li>
                  If you are not at University yet, simply select “Not at
                  University yet” to register your interest in the Programme. We
                  will then get in touch shortly before you start university so
                  you can complete your application.
                </li>
                <Link to="" className="please-note-links">
                  {" "}
                  See more about what you can do prior to starting University.{" "}
                </Link>
                <li>
                  If you graduated from University in 2020 and you lived in the
                  London Borough of Southwark while at Sixth Form/College,
                  please contact StephanieL on{" "}
                  <Link
                    className="please-note-links"
                    to="mailto: stephaniel@upreach.org.uk"
                  >
                    {" "}
                    stephaniel@upreach.org.uk{" "}
                  </Link>{" "}
                  so we can progress your application.{" "}
                </li>
                <Link className="please-note-links" to="">
                  See more about eligibility for the Southwark Internship
                  Programme.
                </Link>
              </ol>
            </div> */}
          </div>
        </div>
      </div>
      <div
        className="apply-now margin-top"
        style={{ background: data.CtaBgcolor }}
      >
        <span
          onClick={() => {
            trackApplyClick();
            goToFormWithUTMs('apply-now/submit');
          }}
          className="flat-btn-link"
        >
          <span className="flat-button">{data.applyCta}</span>
        </span>
      </div>
      {/* comeneted due to Tc.852 change form model popup to New page */}
      {/* {modalOpen && (
        <ApplyNowModal
          setModalOpen={setModalOpen}
          modalOpen={modalOpen}
          notifyFn={notify}
          notifyFn1={notifyFn1}
          token={urlToken}
        />
      )} */}
      </div>
    </StyledWrapper>
  );
};

export default ApplyNowSummary;
